import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "course-preview" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", null, "Dein gewählter Kurs:", -1)
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, "Dein Probetraining absolvierst zu diesem Termin (bitte auswählen):", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("i", null, "Aktuell gibt es keinen kommenden Kurstermin. Du wirst daher nur zum Kurs angemeldet und erhältst deine Probestunde für einen späteren Einsatz gutgeschrieben.")
], -1)
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = { key: 2 }
const _hoisted_10 = { class: "mb-3" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", {
  for: "register-input-appointment",
  class: "form-label"
}, "Dein kostenloses Probetraining absolvierst zu diesem Termin (bitte auswählen):", -1)
const _hoisted_12 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FieldError = _resolveComponent("FieldError")!

  return (_ctx.course)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          (_ctx.course)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("p", null, [
                  _createElementVNode("i", null, _toDisplayString(_ctx.course.course_type.name) + ", " + _toDisplayString(_ctx.course.weekday_label) + " um " + _toDisplayString(String(_ctx.course.start_hours).padStart(2, '0') + ':' + String(_ctx.course.start_minutes).padStart(2, '0')) + " Uhr in " + _toDisplayString(_ctx.course.region.name), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.appointments)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_8))
            : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _withDirectives(_createElementVNode("select", {
                    class: _normalizeClass(["form-select", {'is-invalid': _ctx.validationErrors && _ctx.validationErrors.length > 0}]),
                    "aria-label": "Region",
                    id: "register-input-appointment",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedAppointmentId) = $event))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.appointments, (appointment) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: appointment.id,
                        value: appointment.id
                      }, _toDisplayString(_ctx.formatDatetime(appointment.start)), 9, _hoisted_12))
                    }), 128))
                  ], 2), [
                    [_vModelSelect, _ctx.selectedAppointmentId]
                  ]),
                  _createVNode(_component_FieldError, {
                    errors: _ctx.validationErrors || []
                  }, null, 8, ["errors"])
                ])
              ]))
        ])
      ]))
    : _createCommentVNode("", true)
}